import PropTypes from "prop-types";
import { Accordion as BSAccordion } from "react-bootstrap";

import { AccordionContainer } from "./Accordion.styles";

export const Accordion = ({ heading = "<heading>", children, items }) => {
  return (
    <AccordionContainer>
      <BSAccordion>
        <>
          {heading && children && !items && (
            <BSAccordion.Item eventKey={0}>
              <BSAccordion.Header>{heading}</BSAccordion.Header>
              <BSAccordion.Body>{children}</BSAccordion.Body>
            </BSAccordion.Item>
          )}

          {items &&
            items.map((item, i) => (
              <BSAccordion.Item key={i} eventKey={i}>
                <BSAccordion.Header>{item.title}</BSAccordion.Header>
                <BSAccordion.Body>{item.body}</BSAccordion.Body>
              </BSAccordion.Item>
            ))}
        </>
      </BSAccordion>
    </AccordionContainer>
  );
};

Accordion.propTypes = {
  items: PropTypes.array,
  children: PropTypes.node,
  heading: PropTypes.string,
};
